import React from "react";
import stringHelpers from "../helpers/stringHelpers";

const Text = ({
  text,
  withinContainer,
  displayAsInlineBlock,
  accordionHtmlHack,
}) => {
  if (accordionHtmlHack) {
    text = text.replace(
      /(<ul class="accordion tps-accordion)/gm,
      `$1 htmlhack`
    );
  }
  const element = (
    <div
      className="textComponent mPadding tInfo"
      style={{
        display: displayAsInlineBlock ? "inline-block" : "block",
      }}
      dangerouslySetInnerHTML={{
        __html: text ? stringHelpers.imagePathReplace(text) : "",
      }}
    ></div>
  );

  return withinContainer ? (
    <div className={"grid-container"}>{element}</div>
  ) : (
    element
  );
};

export default Text;
